export function getInitials(fullName: string | null, email: string | null): string {
	if (fullName?.trim()) {
		const parts = fullName.trim().split(/\s+/);
		return parts
			.map((p) => p[0])
			.join('')
			.toUpperCase()
			.slice(0, 2);
	}
	// Solo lettere: «3.folgori@…» dava «3» (N-18, come sul mobile in INB-378).
	return (
		(email ?? '')
			.replace(/[^a-z]/gi, '')
			.slice(0, 1)
			.toUpperCase() || '?'
	);
}
